import type { components } from "@cntrl/api-client";
import { todayIso } from "./bookingRows.js";

type SettlementDto = components["schemas"]["SettlementDto"];
type UpdateSettlementRequest = components["schemas"]["UpdateSettlementRequest"];

/** The body for "the deposit arrived", stamped today.
 *
 *  `depositCents` is what the deal AGREED, not proof it came in (it meant "received" until 2026-08-25) —
 *  `depositReceivedOn` is the arrival. This builds the PUT that stamps it.
 *
 *  The settlement PUT is a WHOLE-DOCUMENT write, so every other scalar has to ride along off the loaded
 *  record: sending only the stamp blanks the door counts, the splits and the merch rates. That is not
 *  hypothetical — it is the failure the settlement panel had to be fixed for, and the reason this lives in
 *  `lib/` rather than at a call site. TWO surfaces stamp a deposit now (the show preview's footer button and
 *  the Booking row's Unpaid chip), and a second hand-rolled copy of a whole-document body is exactly how a
 *  field gets dropped on one surface and not the other — the `showBodyFrom` precedent, same reasoning.
 *
 *  The DEAL (guarantee / door split % / threshold) is deliberately absent: it belongs to `show_finances` and
 *  this PUT ignores it, so there is nothing here to preserve. (Settlement expenses + payouts were removed
 *  2026-09-28.) */
export function markDepositReceivedBody(d: SettlementDto): UpdateSettlementRequest {
  return {
    presaleSold: d.presaleSold, presalePriceCents: d.presalePriceCents,
    walkupSold: d.walkupSold, walkupPriceCents: d.walkupPriceCents,
    vipCount: d.vipCount, vipPriceCents: d.vipPriceCents,
    merchGrossCents: d.merchGrossCents,
    merchSoftGoodsPct: d.merchSoftGoodsPct, merchRecordedPct: d.merchRecordedPct,
    depositCents: d.depositCents,
    depositReceivedOn: todayIso(),
  };
}
